// open header on hover starts
// window.onload = function() {
//   document.getElementById("loaderpage").style.display = "none";
// };
if ($(window).width() > 990) {
  let hoverTimeout;
  $(".header__inline-menu ul li header-menu").hover(
    function () {
      let _this = $(this);
      hoverTimeout = setTimeout(function () {
        _this.children("details").attr("open", "true");
      }, 300); // Adjust delay time (300ms)
    },
    function () {
      clearTimeout(hoverTimeout);
      $(this).children("details").removeAttr("open");
    }
  );
}

// open header on hover ends

// testimonial slider starts here

$('.testimonial-slider-main .multicolumn-list').slick({
  dots: true,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        arrows: false,
        slidesToScroll: 1,
      }
    },
  ]
});
// testimonial slider ends here

// mega menu hover effect starts here

document.addEventListener('DOMContentLoaded', () => {
  const megaMenuContent = document.querySelector('.mega-menu__content');
  const secondMegaMenus = document.querySelectorAll('.second-mega-menu');
  const levelOneMenuItems = document.querySelectorAll('.header__menu-item.level-one');
  secondMegaMenus.forEach(menu => {
    menu.addEventListener('mouseenter', () => {
      document.querySelectorAll('.last-menu-ul').forEach(lastMenu => {
        lastMenu.classList.remove('open');
      });
      const lastMenu = menu.querySelector('.last-menu-ul');
      if (lastMenu) {
        lastMenu.classList.add('open');
      }
    });
  });

  levelOneMenuItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
      document.querySelectorAll('.last-menu-ul').forEach(lastMenu => {
        lastMenu.classList.remove('active');
      });
      const firstLastMenu = item.querySelector('.last-menu-ul');
      if (firstLastMenu) {
        firstLastMenu.classList.add('active');
      }
    });
  });

  if (megaMenuContent) {
    megaMenuContent.addEventListener('mouseleave', () => {
      document.querySelectorAll('.last-menu-ul').forEach(lastMenu => {
        lastMenu.classList.remove('open');
        lastMenu.classList.remove('active');
      });
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const megaMenuLists = document.querySelectorAll('.mega-menu__list');
  megaMenuLists.forEach(megaMenuList => {
    const firstMenuItem = megaMenuList.querySelector('.second-mega-menu');
    if (firstMenuItem) {
      firstMenuItem.classList.add('active');
    }
  });
});

// mega menu hover effect ends here


// sub collections slider starts here

$('.custom-subcollection .subcollections-list__content').slick({
  dots: false,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 7,
  slidesToScroll: 7,
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 4,
        arrows: false,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3.7,
        arrows: false,
        slidesToScroll: 1,
      }
    },
  ]
});

// sub collections slider ends here

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".acc-contact-btn").forEach(button => {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      const target = document.querySelector("#ask-qustion-acc");
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  });
});

// fix sorting starts 
document.addEventListener("DOMContentLoaded", function () {
    const sortSelectors = document.querySelectorAll("#FacetSortForm .facet-filters__sort, #SortBy-mobile");
    if (!sortSelectors.length) return;

    sortSelectors.forEach(sortSelect => {
        sortSelect.addEventListener("change", function () {
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);

            // Preserve all parameters that start with 'filter_'
            let preservedParams = {};
            params.forEach((value, key) => {
                if (key.startsWith("filter_")) {
                    preservedParams[key] = value;
                }
            });

            // Update sorting parameter
            params.set("sort_by", this.value);

            // Reapply preserved parameters
            Object.keys(preservedParams).forEach(key => {
                params.set(key, preservedParams[key]);
            });

            // Redirect with updated parameters
            window.location.href = url.pathname + "?" + params.toString();
        });
    });
});
// fix sorting ends 

$(document).ready(function () {
    $('.coll__detail .Read__More__BTN').click(function () {
      $(this).addClass('hide'),
        $('.coll__detail .coll_content').addClass('open'),
        $('.coll__detail .Read__less__BTN').removeClass('hide');
    }),
      $('.coll__detail .Read__less__BTN').click(function () {
        $(this).addClass('hide'),
          $('.coll__detail .coll_content').removeClass('open'),
          $('.coll__detail .Read__More__BTN').removeClass('hide');
      });
  });




